import { render, staticRenderFns } from "./TicketsSystemListEmpty.vue?vue&type=template&id=fa06699a&"
import script from "./TicketsSystemListEmpty.vue?vue&type=script&lang=js&"
export * from "./TicketsSystemListEmpty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports